import React from 'react';
import CreateOrganisationLayout from "../components/administration/CreateOrganisationLayout";

function CreateOrganisationPage() {

    return <CreateOrganisationLayout />;
}

export default CreateOrganisationPage;
